import script from "./ContatoreTable4.vue?vue&type=script&setup=true&lang=js"
export * from "./ContatoreTable4.vue?vue&type=script&setup=true&lang=js"

import "./ContatoreTable4.vue?vue&type=style&index=0&id=0f71ddff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f71ddff"]])

export default __exports__